import {AnalyticsBrowser} from '@segment/analytics-next';

import {extractLoginAppSettings} from '@/utils/extractLoginAppSettings';

const {segmentWriteKey, segmentCDNProxy} = extractLoginAppSettings();

export const analytics = !!segmentWriteKey
  ? AnalyticsBrowser.load({
      writeKey: segmentWriteKey,
      cdnURL: segmentCDNProxy === '' ? undefined : segmentCDNProxy,
    })
  : undefined;
